import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaTiktok } from "react-icons/fa";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState({ success: null, message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponse({ success: null, message: "" });

    try {
      const web3FormsUrl = "https://api.web3forms.com/submit";
      const WEB3FORMS_ACCESS_KEY = process.env.REACT_APP_WEB3FORMS_KEY;

      const res = await fetch(web3FormsUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: WEB3FORMS_ACCESS_KEY,
          email,
          subject: "New Newsletter Subscription",
          message: `New subscription from: ${email}`,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setResponse({
          success: true,
          message: data.message || "Thank you for subscribing! 🎉",
        });
        setEmail(""); // Clear input field
      } else {
        setResponse({
          success: false,
          message: data.message || "Failed to subscribe. Please try again.",
        });
      }
    } catch (error) {
      console.error("Web3Forms Error:", error);
      setResponse({
        success: false,
        message: "Network error. Please check your connection and try again.",
      });
    } finally {
      setLoading(false);
      setTimeout(() => setResponse({ success: null, message: "" }), 5000);
    }
  };

  return (
    <footer className="bg-white py-10 text-black">
      <div className="max-w-7xl mx-auto px-4 flex flex-wrap justify-between gap-6">
        <div>
          <h3 className="font-bold text-xl">Gridograph</h3>
          <p className="text-gray-500 mt-2">Akoka Yaba, Lagos, Nigeria.</p>
        </div>

        {/* Links */}
        <div>
          <h4 className="font-semibold">Links</h4>
          <ul className="text-gray-500 mt-2 space-y-2">
            <li>
              <Link to="/" className="hover:text-gray-700">Home</Link>
            </li>
            <li>
              <Link to="/collection" className="hover:text-gray-700">Shop</Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-gray-700">Contact</Link>
            </li>
          </ul>
          <div className="flex items-start gap-4 mt-4">
            <a href="https://www.instagram.com/gridograph/" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="text-pink-500 text-2xl" />
            </a>
            <a href="https://www.tiktok.com/@gridograph" target="_blank" rel="noopener noreferrer">
              <FaTiktok className="text-black text-2xl" />
            </a>
          </div>
        </div>

        {/* Help */}
        <div>
          <h4 className="font-semibold">Help</h4>
          <ul className="text-gray-500 mt-2 space-y-2">
            <li>
              <Link className="hover:text-gray-700">Returns</Link>
            </li>
            <li>
              <Link className="hover:text-gray-700">Privacy Policies</Link>
            </li>
          </ul>
        </div>

        {/* Newsletter */}
        <div>
          <h4 className="font-semibold">Newsletter</h4>
          <form onSubmit={handleSubmit} className="mt-2">
            <div className="flex border border-gray-300 overflow-hidden">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Your Email Address"
                className="p-2 w-full focus:outline-none"
                required
              />
              <button type="submit" className="bg-black text-white font-semibold px-4" disabled={loading}>
                {loading ? "Subscribing..." : "SUBSCRIBE"}
              </button>
            </div>
          </form>
          {response.message && (
            <p className={`${response.success ? "text-green-600" : "text-red-600"} mt-2`}>
              {response.message}
            </p>
          )}
        </div>
      </div>

      {/* Copyright */}
      <div className="text-center text-gray-500 mt-8">
        <p>©️ 2025 Gridograph. All rights reserved</p>
      </div>
    </footer>
  );
};

export default Footer;
